import activationAnalyticsService from "../services/activationAnalytics.service";
import {
  GET_ACTIVATION_ANALYTICS_FIREBASE_EVENTS,
} from "./types";

export const getActivationAnalyticsFirebaseEventsAction = (params) => (dispatch) => {
  return activationAnalyticsService.getActivationAnalyticsFirebaseEvents(params).then((resp) => {
    if (resp.status) {
      dispatch({ type: GET_ACTIVATION_ANALYTICS_FIREBASE_EVENTS, payload: resp.data });
    } else {
      dispatch({ type: GET_ACTIVATION_ANALYTICS_FIREBASE_EVENTS, payload: {} });
    }
    return resp;
  });
};
